import { ROUTES } from '../routes';

export const PHONE = {
  label: '13 MYLO (13 69 56)',
  short: '13 69 56',
  href: 'tel:136956',
};

export const EMAIL = {
  address: 'office@mylo.com.au',
  href: 'mailto:office@mylo.com.au',
};

export const PORTAL_URL = 'https://myloportal.com.au';
export const TERMS_AND_CONDITIONS_URL = ROUTES.termsAndConditions;
export const QLD_2027_REQUIREMENTS_URL = 'https://upgrade.mylo.com.au/';
export const QLD_SELLER_REQUIREMENTS_URL = 'https://sellers.mylo.com.au/';
export const ENROL_A_PROPERTY_FORM_URL = 'https://enrol.mylo.com.au';

export const OFFICES = {
  VIC: {
    state: 'VIC',
    name: 'Victoria',
    addressLines: ['Level 1, 469-479 Glen Huntly Road', 'Elsternwick VIC 3185'],
    structuredAddress: {
      streetAddress: 'Level 1, 469-479 Glen Huntly Road',
      addressLocality: 'Elsternwick',
      addressRegion: 'VIC',
      postalCode: '3185',
      addressCountry: 'AU',
    },
  },
  NSW: {
    state: 'NSW',
    name: 'New South Wales',
    addressLines: ['Tower 2, 1705/101 Grafton St', 'Bondi Junction NSW 2022'],
    structuredAddress: {
      streetAddress: 'Tower 2, 1705/101 Grafton St',
      addressLocality: 'Bondi Junction',
      addressRegion: 'NSW',
      postalCode: '2022',
      addressCountry: 'AU',
    },
  },
  QLD: {
    state: 'QLD',
    name: 'Queensland',
    addressLines: ['1/572 Curtin Avenue East', 'Eagle Farm QLD 4009'],
    structuredAddress: {
      streetAddress: '1/572 Curtin Avenue East',
      addressLocality: 'Eagle Farm',
      addressRegion: 'QLD',
      postalCode: '4009',
      addressCountry: 'AU',
    },
  },
};

export const SOCIAL_LINKS = [
  { label: 'Instagram', href: 'https://www.instagram.com/mylopropertysolutions_' },
  { label: 'Facebook', href: 'https://www.facebook.com/mylopropertysolutions/' },
  { label: 'LinkedIn', href: 'https://au.linkedin.com/company/mylo-services' },
];

export const DIVISIONS = {
  safety: {
    key: 'safety',
    name: 'MYLO Safety',
    shortName: 'Safety',
    route: ROUTES.safety,
    colour: '#cf2930',
    colourFaded: '#cf293099',
    theme: 'theme-safety',
  },
  tradies: {
    key: 'tradies',
    name: 'MYLO Tradie Services',
    shortName: 'Tradie Services',
    route: ROUTES.tradies,
    colour: '#f56329',
    colourFaded: '#f5632999',
    theme: 'theme-tradies',
  },
  homeMods: {
    key: 'homeMods',
    name: 'MYLO Home Modifications',
    shortName: 'Home Modifications',
    route: ROUTES.homeModifications,
    colour: '#1c75ba',
    colourFaded: '#1c75ba99',
    theme: 'theme-home-mods',
  },
};

export const MYLO_YELLOW = '#fdde42';
export const COPYRIGHT = '© MYLO 2026';
